module.exports = __webpack_public_path__ + "img/art_1_4.407a68aa.png";